import ReactGAModule from 'react-ga4';

const ReactGA = [
  ReactGAModule?.default?.default,
  ReactGAModule?.default,
  ReactGAModule,
].find((candidate) => typeof candidate?.initialize === 'function');

// GA4 event names must start with a letter and contain only letters,
// numbers, and underscores, up to 40 characters.
// https://support.google.com/analytics/answer/13316687
function toGA4EventName(action = '') {
  let name = action
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  if (name && !/^[a-z]/.test(name)) {
    name = `event_${name}`;
  }

  return name.slice(0, 40).replace(/_+$/, '');
}

export function GAInitialize(trackingId) {
  try {
    if (typeof ReactGA?.initialize !== 'function') return;
    ReactGA.initialize(trackingId);
  } catch {
    // Never let analytics failures break app startup.
  }
}

export function GAPageView(page, title) {
  try {
    if (typeof ReactGA?.send !== 'function') return;
    ReactGA.send({ hitType: 'pageview', page, title });
  } catch {
    // Never let analytics failures break navigation.
  }
}

/**
 * Send a custom event to GA4.
 * `action` is converted into a GA4-compliant snake_case event name;
 * category/label/value are sent along as event parameters.
 *
 * @param {string} category - Event category (e.g. 'class search')
 * @param {string} action   - Event action (e.g. 'Search Classes button click')
 * @param {string} [label]  - Optional label for additional context
 * @param {number} [value]  - Optional numeric value
 */
export function GAEvent(category, action, label, value) {
  try {
    if (typeof ReactGA?.event !== 'function') return;

    const eventName = toGA4EventName(action);
    if (!eventName) return;

    ReactGA.event(eventName, {
      category,
      label,
      value,
    });
  } catch {
    // Never let analytics failures break the user action that triggered them.
  }
}
